module.exports = {
	"prova": "prova"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/json-loader!./public/resources/properties.json
 ** module id = 367
 ** module chunks = 0
 **/